import { apiClient, type GameSession } from './client';
import type { ApiResponse } from '../types';

export interface PublicUser {
  user_id: string;
  email: string;
  name: string;
  role: string;
}

export interface StudentAuthResult {
  user: PublicUser;
  universe: {
    universe_id: string;
    name: string;
    universe_type: string;
    joinCode: string;
  };
  planet: {
    planet_id: string;
    owner_user_id: string;
    universe_id: string;
    name: string;
    stage: number;
  };
  session: GameSession;
}

export interface TeacherAuthResult {
  user: PublicUser;
  session: GameSession;
}

export type AuthResult = StudentAuthResult;

export const authApi = {
  studentJoin: (input: { username: string; universeCode?: string; password: string; displayName?: string; joinMode?: 'public' | 'teacherCode' }) =>
    apiClient.post<ApiResponse<StudentAuthResult>>('/auth/student/join', input).then((r) => r.data),
  studentLogin: (input: { username: string; universeCode?: string; password: string; joinMode?: 'public' | 'teacherCode' }) =>
    apiClient.post<ApiResponse<StudentAuthResult>>('/auth/student/login', input).then((r) => r.data),
  teacherRegister: (input: { email: string; password: string; name?: string }) =>
    apiClient.post<ApiResponse<TeacherAuthResult>>('/auth/teacher/register', input).then((r) => r.data),
  teacherLogin: (input: { email: string; password: string }) =>
    apiClient.post<ApiResponse<TeacherAuthResult>>('/auth/teacher/login', input).then((r) => r.data),
  session: () =>
    apiClient.get<ApiResponse<{ user: PublicUser; session: Omit<GameSession, 'token' | 'expiresAt'>; planet?: StudentAuthResult['planet'] | null }>>('/auth/session').then((r) => r.data),
  join: (input: { username: string; universeCode?: string; password: string; displayName?: string; joinMode?: 'public' | 'teacherCode' }) =>
    apiClient.post<ApiResponse<StudentAuthResult>>('/auth/join', input).then((r) => r.data),
  login: (input: { username: string; universeCode?: string; password: string; joinMode?: 'public' | 'teacherCode' }) =>
    apiClient.post<ApiResponse<StudentAuthResult>>('/auth/login', input).then((r) => r.data),
};
